import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { liveAgentChatCountAction } from "../../../../sagas/saga-actions";
import { revokeClientByAgent } from "../../../../sagas/saga-revokeClient";
import { sendUploadLinkByUserSagaAction } from "../../../../sagas/saga-uploadLink";
import { sendDocumentSignLinkSagaAction } from "../../../../sagas/saga-docSignLink";
import { downloadSignedDocSagaAction } from "../../../../sagas/saga-docSignDownload";
import ConfirmPopup from "../../../../components/confirmPopup";
import { setPopup } from "../../../../actions/popupAction";
import TransferPopup from "../../../transferPopup";

import CustomButton from "../../../../components/customButton";

const UserHeader = (props) => {
  const tabSet = localStorage.getItem("tabSetAgent");
  const [state, setState] = useState({
    patientDocSignStatus: {},
    closePopup: false,
    transferPopup: false,
  });

  const updateDocSignStatus = (data) => {
    const patientId = data.patientId;
    if (data.patientId) {
      delete data.patientId;
      let patientDocSignStatus = state.patientDocSignStatus;
      patientDocSignStatus[patientId] = data;
      setState((st) => ({ ...st, patientDocSignStatus }));
    }
  };

  const revokeChat = () => {
    const { user, isNewClient } = props;
    const object = {
      userId: user.id,
      clientId: isNewClient.id,
    };
    props.revokePatientByAgent(object, () => {
      props.liveAgentChatCount();
      const event = new CustomEvent("revokeChat");
      window.dispatchEvent(event);
      props.setPopup({
        customPopupMessage: true,
        message: "The chat has been moved to Closed chats.",
        messageType: "success",
      });
    });
  };

  useEffect(() => {
    // declaring local to be used in the event handler
    const _updateDocSignStatus = (data) => {
      updateDocSignStatus(data);
    };

    // socket event listener for socket service
    window.addEventListener(
      "updateDocSignLinkStatus",
      (e) => {
        let { msg } = e.detail;
        _updateDocSignStatus(msg);
      },
      false
    );
  }, []);

  const handleCancel = () => {
    setState((st) => ({ ...st, transferPopup: false }));
  };

  const { client, isNewClient } = props;

  return (
    <>
      {state.closePopup && (
        <ConfirmPopup
          isDelete
          titleMessage="Confirm to Close"
          handleCancel={() => setState((st) => ({ ...st, closePopup: false }))}
          handleDelete={revokeChat}
          isVisible={state.closePopup}
          submitButtonText="Close Chat"
          cancelButtonText="Cancel"
          message="Are you sure you want to close this chat?"
        />
      )}

      {state.transferPopup && (
        <TransferPopup
          handleCancel={handleCancel}
          isLiveAgent={true}
          handleAgentChat={props.handleAgentChat}
        />
      )}
      {isNewClient &&
        isNewClient.email && (
          <div className="chat-header-wrapper">
            <div className="current-user-detail">
              <span className="online-icon" />
              <p className="name">
                {isNewClient.name ? `${isNewClient.name || ""} ` : client.email}
              </p>
              <p className="email">{isNewClient.email}</p>
            </div>

            {tabSet && tabSet === "activeChat" ? (
              <>
                <div className="header-buttons">
                  <CustomButton
                    btntype="clear"
                    title="Transfer Number"
                    onClick={() =>
                      setState((st) => ({ ...st, transferPopup: true }))
                    }
                  />

                  <CustomButton
                    btntype="clear"
                    title="Close Chat"
                    onClick={() =>
                      setState((st) => ({ ...st, closePopup: true }))
                    }
                  />
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    client: state.patients,
    isNewClient: state.patients.patient,
    user: state.login.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendUploadLinkToPatient: bindActionCreators(
      sendUploadLinkByUserSagaAction,
      dispatch
    ),
    sendDocSignLinkToPatient: bindActionCreators(
      sendDocumentSignLinkSagaAction,
      dispatch
    ),
    revokePatientByAgent: bindActionCreators(revokeClientByAgent, dispatch),
    liveAgentChatCount: () => dispatch(liveAgentChatCountAction()),
    setPopup: (data) => dispatch(setPopup(data)),
    downloadSignedDocument: bindActionCreators(
      downloadSignedDocSagaAction,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserHeader);
